export default {"src":"/_next/static/media/person-success.8238560a.svg","height":30,"width":32};